<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-12-14                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <yega1-idle-watcher
        v-on:timeout="signOutRedirectHome">
    </yega1-idle-watcher>
    <router-view name="navigation"></router-view>
    <router-view name="main"></router-view>
    <yega1-loading-spinner message="Loading, please wait..."></yega1-loading-spinner>
  </div>
</template>

<script>
import router from './router';
import store from './store'
import Yega1IdleWatcher from "../../components/yega/yega1/yega1-idle-watcher.vue";
import Yega1LoadingSpinner from "../../components/yega/yega1/yega1-loading-spinner.vue";
import SignOutRedirectHomeMixin from "../../mixins/sign-out-redirect-home";
import LoadingSpinnerInterceptorMixin from "../../mixins/loading-spinner-interceptor";

export default {
  name: "app",
  mixins: [SignOutRedirectHomeMixin,LoadingSpinnerInterceptorMixin],
  router,
  store,
  components:{
    Yega1LoadingSpinner,
    Yega1IdleWatcher
  }
}
</script>

<style scoped>

</style>
